import { ITranslationMap } from "./ITranslationMap.i18n";

export const translations: ITranslationMap = {
  // Meilensteinprojekt
  generelleInfo: "Generelle Info",
  tragwerksplanung: "Tragwerksplanung",
  brandschutz: "Brandschutz",
  bauphysikUndNachhaltigkeit: "Bauphysik und Nachhaltigkeit",
  zirkulaeresBauen: "Zirkuläres Bauen",
  innovation: "Innovation",
  historischeBedeutung: "Historische Bedeutung",

  // Meilenstein Zahlen und Fakten
  bauart: "Nutzung",
  fertigstellung: "Fertigstellung",
  bauzeit: "Bauzeit",
  montageHolzbau: "Montage Holzbau",
  verbautesHolz: "Verbautes Holz",
  groessteSpannweite: "Grösste Spannweite",
  geschosse: "Geschosse",
  gebaeudegrundflaeche: "Gebäudegrundfläche",
  geschossflaeche: "Geschossfläche",
  gebaeudevolumen: "Gebäudevolumen",
  kostenHolzbau: "Kosten Holzbau",
  erstellungskosten: "Erstellungskosten",
};
